import React, { Component } from "react";

export default class PayForm extends Component {
  render() {
    const {
      ctId,
      mpsMode,
      currCode,
      amount,
      lang,
      cancelUrl,
      failUrl,
      successUrl,
      merchantId,
      payType,
      payMethod,
      asiapayUrl,
      secureHash,
      remark,
      failRetry
    } = this.props.tempOrderResponseData;
    return (
      <>
        <form
          id="payForm"
          hidden=""
          name="payForm"
          method="post"
          action={asiapayUrl}
        >
          <input type="hidden" name="orderRef" value={ctId} />
          <input type="hidden" name="secureHash" value={secureHash} />
          <input type="hidden" name="mpsMode" value={mpsMode} />
          <input type="hidden" name="currCode" value={currCode} />
          <input type="hidden" name="amount" value={amount} />
          <input type="hidden" name="lang" value={lang} />
          <input type="hidden" name="cancelUrl" value={cancelUrl} />
          <input type="hidden" name="failUrl" value={failUrl} />
          <input type="hidden" name="successUrl" value={successUrl} />
          <input type="hidden" name="merchantId" value={merchantId} />
          <input type="hidden" name="payType" value={payType} />
          <input type="hidden" name="payMethod" value={payMethod} />
          <input type="hidden" name="remark" value={remark} />
          <input type="hidden" name="failRetry" value={failRetry} />
        </form>
        <div className="paymentResult"></div>
      </>
    );
  }
}
